"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MICRONUTRIENTS_AS_MICROGRAMS = exports.getPrintNutritionalInfo = exports.getPrintCalories = void 0;
const effect_1 = require("effect");
const Unit = __importStar(require("../unit"));
const number_1 = require("../utils/number");
/**
 * See point N7 and N8: https://www.fda.gov/files/food/published/Food-Labeling-Guide-%28PDF%29.pdf
 */
const getPrintCalories = (energy) => {
    const usBigCalories = Unit.Energy.convert(energy, 'UsBigCalorie');
    if (usBigCalories.amount < 5)
        return Unit.Energy.UsBigCalorie.make({ amount: 0 });
    if (usBigCalories.amount <= 50)
        return Unit.Energy.UsBigCalorie.make({ amount: (0, number_1.roundToNearest)(usBigCalories.amount, 5) });
    return Unit.Energy.UsBigCalorie.make({ amount: (0, number_1.roundToNearest)(usBigCalories.amount, 10) });
};
exports.getPrintCalories = getPrintCalories;
/**
 * Determines the legally printable nutritional info per serving, according to the FDA guidelines.
 *
 * See: https://www.fda.gov/files/food/published/Food-Labeling-Guide-%28PDF%29.pdf
 *
 * See {@link NutritionalInfo}
 */
const getPrintNutritionalInfo = (nutritionalInfo) => ({
    ...nutritionalInfo,
    energy: (0, exports.getPrintCalories)(nutritionalInfo.energy),
    micro: effect_1.Record.map(nutritionalInfo.micro, (mg, key) => exports.MICRONUTRIENTS_AS_MICROGRAMS.includes(key) ? Unit.Mass.convert(mg, 'Microgram') : mg),
});
exports.getPrintNutritionalInfo = getPrintNutritionalInfo;
/**
 * The FDA demands that these micronutrients to be printed as micrograms instead of milligrams
 *
 * See {@link Micronutrient}
 */
exports.MICRONUTRIENTS_AS_MICROGRAMS = [
    'biotin',
    'chromium',
    'vitaminA',
    'vitaminB12',
    'vitaminD',
    'vitaminK',
    'folicAcid',
    'iodine',
    'selenium',
    'molybdenum',
];
//# sourceMappingURL=fda.js.map